export const ASM_TRANSLATION_BUNDLES = [
  'asm-platform',
  'asm-components-access-management',
  'asm-components-assets',
  'asm-components-atp',
  'asm-components-automation',
  'asm-components-collaboration',
  'asm-components-core',
  'asm-components-dashboards',
  'asm-components-drp',
  'asm-components-engagements',
  'asm-components-integrations',
  'asm-components-notifications',
  'asm-components-partner-management',
  'asm-components-platform-administration',
  'asm-components-platform-context',
  'asm-components-platform-shell',
  'asm-components-reports',
  'asm-components-scopes',
  'asm-components-search',
  'asm-components-tracker',
  'asm-components-vulnerabilities',
  'sol-components',
];
